/* global.js — Brick District Kits
   Handles: mobile nav toggle, gallery thumbnails, cart badge refresh
*/

(function () {
  'use strict';

  /* ── Mobile nav toggle ───────────────────────────────────── */
  var toggle = document.getElementById('NavToggle');
  var nav    = document.getElementById('HeaderNav');

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target) && !toggle.contains(e.target)) {
        nav.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ── Gallery thumbnail swap ─────────────────────────────── */
  var thumbs   = document.querySelectorAll('.gallery__thumb');
  var mainImg  = document.getElementById('GalleryMainImg');

  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      thumbs.forEach(function (t) {
        t.classList.remove('active');
        t.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');

      if (mainImg) {
        mainImg.removeAttribute('srcset');
        mainImg.src = btn.dataset.src;
        mainImg.alt = btn.dataset.alt || '';
      }
    });
  });

  /* ── Keep cart badge in sync after AJAX adds ────────────── */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('CartCount');
        if (el) el.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  /* Run once on page load to ensure badge is accurate */
  refreshCartCount();

})();
